import * as Api from '@ViewModels';
import { createContext, FC, useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router';
import { useAdminAccountQuery } from '../../../queries';
import { ImpersonationContextViewModel } from '../../../viewmodels/AdminViewModels';

interface IAccountContext {
	account: Api.IAccount;
	accountId: string;
	impersonationContext: Api.IImpersonationContext;
}

const AccountContext = createContext<IAccountContext>({
	account: null,
	accountId: null,
	impersonationContext: null,
});

export const AccountContextProvider: FC<React.PropsWithChildren> = ({ children }) => {
	const { id: accountId } = useParams<{ id: string }>();

	const impersonationContextRef = useRef(
		new ImpersonationContextViewModel({
			account: { id: accountId },
		})
	);

	const { data: account } = useAdminAccountQuery({
		accountId,
		meta: {
			toastErrorMessage: 'Error loading account',
		},
	});

	useEffect(() => {
		if (account) {
			impersonationContextRef.current.update({
				account,
			});
		}
	}, [account]);

	return (
		<AccountContext.Provider value={{ account, accountId, impersonationContext: impersonationContextRef.current }}>
			{children}
		</AccountContext.Provider>
	);
};

export const useAccountContext = () => useContext<IAccountContext>(AccountContext);
